import Navbar from './Navbar';
import Footer from './Footer';
import { ScrollToTop } from './Breadcrumb';

interface LayoutProps {
  children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="min-h-screen">{children}</main>
      <Footer />
    </>
  );
}